var _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMolina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 8,
    y: 38,
    fontFamily: "Arial, sans-serif",
    fontSize: 28,
    fontWeight: 700,
    fill: "#2f3742",
    letterSpacing: -0.5
  }, "Molina")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 8,
    y: 54,
    fontFamily: "Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#555",
    letterSpacing: 0.5
  }, "Healthcare")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMolina);
export default __webpack_public_path__ + "static/media/logo-molina.ee955aca2e5c48cabe93d65b39f1b4df.svg";
export { ForwardRef as ReactComponent };